import $ from 'jquery'
import leaflet from 'VendorWrappers/leaflet.js'
import LeafletSidebar from 'VendorWrappers/sidebar.js'
import AttributionView from './attribution.js'
import UserView from './user.js'
import SettingsView from './settings/view.js'
import ConstraintsView from './constraints/view.js'
import {VisitsMenuView} from './visits/view.js'
import ExternalFilesView from './external-files/files_load_panel.js'
import params from '../params.js'

var MenuView = leaflet.Class.extend({
	initialize: function (manager) {
		this._manager = manager
		this._buildView()
		this._buildControl()
	},

	_buildView: function () {
		var view = ''

		var classes = ['sidebar', 'collapsed', 'leaflet-container']

		var showUserSettings = params.test('testing') == 'true'

		//top of the navigation bar
		view += '<div id="sidebar" class="' + classes.join(' ') + '">'
		view += '    <div class="sidebar-tabs">'
		view += '        <ul role="tablist">'
		view += '            <li><a href="#sidebar-layers" role="tab"><i class="fa fa-bars"></i></a></li>'
		view += '            <li><a href="#sidebar-settings" role="tab"><i class="fa fa-sliders"></i></a></li>'
		view += '            <li><a href="#sidebar-constraints" role="tab"><i class="fa fa-map-o"></i></a></li>'
		view += `            <li>
                                 <a href="#sidebar-visits" role="tab">
                                     <span class="fa fa-stack">
                                         <i class="fa-check fa fa-stack-1x fa-small-icon"></i>
                                         <i class="fa-map-o fa fa-stack-1x"></i>
                                     </span>
                                 </a>
                             </li>`
		view += '            <li><a href="#sidebar-external-files" role="tab"><i class="fa fa-plus-square-o"></i></a></li>'
		view += '        </ul>'

		//bottom of the navigation bar
		view += '        <ul role="tablist">'
		if (showUserSettings) {
			view += '            <li><a href="#sidebar-user" role="tab"><i class="fa fa-user"></i></a></li>'
		}
		view += '            <li><a href="#sidebar-attribution" role="tab"><i class="fa fa-copyright"></i></a></li>'
		view += '        </ul>'
		view += '    </div>'

		//tab contents
		view += '    <div class="sidebar-content">'
		view += '        <div id="sidebar-layers" class="sidebar-pane">'
		view +=
			'            <h1 class="sidebar-header">Layers<span class="sidebar-close"><i class="fa fa-caret-left"></i></span></h1>'
		view += '        </div>'
		view += '        <div id="sidebar-settings" class="sidebar-pane">'
		view +=
			'            <h1 class="sidebar-header">Settings<span class="sidebar-close"><i class="fa fa-caret-left"></i></span></h1>'
		view += '        </div>'
		view += '        <div id="sidebar-constraints" class="sidebar-pane">'
		view +=
			'            <h1 class="sidebar-header">Data Limits<span class="sidebar-close"><i class="fa fa-caret-left"></i></span></h1>'
		view += '        </div>'
		view += '        <div id="sidebar-visits" class="sidebar-pane">'
		view +=
			'            <h1 class="sidebar-header">Upload Visits<span class="sidebar-close"><i class="fa fa-caret-left"></i></span></h1>'
		view += '        </div>'
		view += '        <div id="sidebar-external-files" class="sidebar-pane">'
		view +=
			'            <h1 class="sidebar-header">External Files<span class="sidebar-close"><i class="fa fa-caret-left"></i></span></h1>'
		view += '        </div>'
		view += '        <div id="sidebar-attribution" class="sidebar-pane">'
		view +=
			'            <h1 class="sidebar-header">Attribution<span class="sidebar-close"><i class="fa fa-caret-left"></i></span></h1>'
		view += '        </div>'
		if (showUserSettings) {
			view += '        <div id="sidebar-user" class="sidebar-pane">'
			view +=
				'            <h1 class="sidebar-header">User Settings<span class="sidebar-close"><i class="fa fa-caret-left"></i></span></h1>'
			view += '        </div>'
		}
		view += '    </div>'
		view += '</div>'

		this._view = $(view)
		this._manager.getConfig().map_outer_container_element.append(this._view)

		var attributionContainer = $('<div></div>')
		$('#sidebar-attribution', this._view).append(attributionContainer)
		this._attributionView = new AttributionView(attributionContainer)

		if (showUserSettings) {
			var userView = new UserView(this._manager)
			$('#sidebar-user', this._view).append(userView.getView())
		}

		var settingsView = new SettingsView(this._manager)
		$('#sidebar-settings', this._view).append(settingsView.getView())

		var constraintsView = new ConstraintsView(this._manager)
		$('#sidebar-constraints', this._view).append(constraintsView.getView())

		var visitsView = new VisitsMenuView(this._manager)
		$('#sidebar-visits', this._view).append(visitsView.getView())

		const externalFilesView = new ExternalFilesView(this._manager)
		$('#sidebar-external-files', this._view).append(externalFilesView.getView())
	},

	_buildControl: function () {
		this._control = new LeafletSidebar('sidebar')
	},

	addTo: function (map) {
		this._control.addTo(map)
	},

	getContainer: function () {
		return this._view[0] //get raw dom element from jquery
	},

	addLayers: function (matrixLayerControl) {
		$('#sidebar-layers', this._view).append(matrixLayerControl.getContainer())
	},

	addAttribution: function (dataSourceName, text) {
		this._attributionView.addAttribution(dataSourceName, text)
	}
})

export default MenuView
